import * as AdminService from '../../../services/AdminService';

export const FETCH_NODE_INFO = 'FETCH_NODE_INFO';
export const fetchNodeInfo = resourceId => ({
    type: FETCH_NODE_INFO,
    payload: AdminService.fetchNodeInfo(resourceId),
});
